/*eslint-disable*/
// src/utils/calcProfile.js  ← این فایل را کامل جایگزین کن
import { THERAPIST_PROFILES } from '../data/therapistProfiles'

// مجموعه اسلاگ‌های معتبر از پروفایل‌ها
const VALID = new Set(THERAPIST_PROFILES.map(p => p.slug))

// نرمال‌سازی اسلاگ (حروف کوچک، حذف فاصله) + چند نگاشت رایج
const NORMALIZE_MAP = { deBotton: 'debotton', DeBotton: 'debotton' }
const norm = s => (s || '').toString().trim().toLowerCase().replace(/\s+/g, '')

export function calcProfile (selectedOptions) {
  // 1) پاک‌سازی: فقط گزینه‌هایی که therapist معتبر دارند
  const clean = selectedOptions
      .map(o => {
        const raw = o.therapist
        const slug = NORMALIZE_MAP[raw] || norm(raw)
        return { ...o, _slug: slug }
      })
      .filter(o => VALID.has(o._slug))

  // 2) امتیازدهی
  const scores = {}
  clean.forEach(o => { scores[o._slug] = (scores[o._slug] || 0) + 1 })

  // 3) قاعدهٔ ویژه: ۴ انتخاب زرد → شایگان
  if ((scores['shayegan'] || 0) >= 4) {
    return THERAPIST_PROFILES.find(p => p.slug === 'shayegan')
  }

  // 4) اگر هیچ گزینهٔ معتبر نبود، لاگ + فالبک امن
  const entries = Object.entries(scores)
  if (!entries.length) {
    console.warn('[calcProfile] No valid therapist slugs in answers:', selectedOptions)
    return THERAPIST_PROFILES.find(p => p.slug === 'frankl') || THERAPIST_PROFILES[0]
  }

  // 5) بیشترین رأی + شکستن تساوی با «آخرین پاسخ»
  entries.sort((a, b) => b[1] - a[1])
  const topScore = entries[0][1]
  const leaders = entries.filter(([s, c]) => c === topScore).map(([s]) => s)
  let winner = leaders[0]
  const last = clean[clean.length - 1]?._slug
  if (last && leaders.includes(last)) winner = last

  return THERAPIST_PROFILES.find(p => p.slug === winner) || THERAPIST_PROFILES[0]
}
